import { flow } from 'lodash';

import { NAME } from './configuration.constant';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateKey);
